import ID from './media/brand/id.svg';

const Brand = {
    ID
};

export default Brand;
